module.exports = __webpack_public_path__ + "static/media/fm-icons-Comments.932cd6da.svg";